/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Repeat of the session. 'CUSTOM' = explicit per-date slots in customSlots.
 */
export enum SessionRepeat {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  WEEKDAYS = 'WEEKDAYS',
  NONE = 'NONE',
  CUSTOM = 'CUSTOM'
}
